import Vue from 'vue'
import Router from 'vue-router'
import ngConfig from "@/config"
import LayoutTopBtm from "@/components/layout/LayoutTopBtm"

Vue.use(Router)

const constantRouterMap = [
  {
    path: '',
    redirect:'/login'
  },
  {
    path: '/login',
    component: () => import('../views/login'),
    name: '登录',
    hidden: true
  },
  {
    path: '/step',
    component: () => import('../views/out'),
    name: '注册',
    children:[{
      path: 'step1',
      component: () => import('../views/out/step1'),
      name: '注册1',
    },
    {
      path: 'step2',
      component: () => import('../views/out/step2'),
      name: '注册2',
    },{
      path: 'step3',
      component: () => import('../views/out/step3'),
      name: '注册3',
    }
    ],
    hidden: true
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/desktop')
  },
  {
    path: '/supplier',
    name: 'supplier',
    component: () => import('../views/desktop/supplier')
  },
  
  { path: '/404', component: () => import('@/errorPage/404'), hidden: true },
  { path: '*', redirect: '/404', hidden: true },
  {
    path: '/aside',
    name: 'aside',
    component: LayoutTopBtm,
    children:[
      {
        path: 'details',
        name: '详情信息',
        component: () => import('../views/aside/details'),
        meta: { title: '详情信息', icon: 'el-icon-remove-outline' }
      },
      {
        path: 'detailsBio',
        name: '详情信息',
        component: () => import('../views/aside/detailsBio'),
        meta: { title: '详情信息', icon: 'el-icon-remove-outline' }
      },
      {
        path: 'list',
        name: '信息列表',
        component: () => import('../views/aside/list'),
        meta: { title: '信息列表', icon: 'el-icon-remove-outline' }
      }
    ]
  },
]


let routerOptions = {};
if(process.env.NODE_ENV === 'development'){
  routerOptions = {
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  }
}else{
  routerOptions = {
    base:ngConfig.desktop,
    mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  }
}

export default new Router(routerOptions)



// WEBPACK FOOTER //
// ./src/modules/desktop/router/index.js